<template>
  <div>
    <!-- 头部搜索栏 -->
    <div class="book-top">
      <RetrieveDetailSearch :bookId="bookId"></RetrieveDetailSearch>
    </div>
    <div class="book-middle">
      <div class="box">
        <!-- <div class="left-menu" v-show="isShow">
          <RetrieveLeftMenu></RetrieveLeftMenu>
        </div>
        <div class="button-class">
          <img
            v-if="isShow"
            src="@/assets/images/bookIcons/show.png"
            class="hide"
            @click="isShow = false"
          />
          <img
            v-else
            src="@/assets/images/bookIcons/hide.png"
            class="hide"
            @click="isShow = true"
          />
        </div> -->
        <div class="left-menu">
          <div class="left2">
            <img
              src="@/assets/images/bookIcons/leftmenutop.png"
              alt=""
              class="img-top"
            />
            <div>
              <div class="bookName">{{ bookName }}</div>
              <el-tabs v-model="activeName" type="card" class="tab">
                <el-tab-pane label="书目信息" name="first">
                  <el-tree
                    ref="tree"
                    class="tree"
                    id="tree"
                    :data="catalog"
                    node-key="page"
                    :props="defaultProps"
                    :highlight-current="true"
                    :current-node-key="currentPage"
                    @node-click="handleNodeClick"
                  >
                    <span slot-scope="{ data }" style="width:135px">
                      <el-tooltip
                        effect="light"
                        placement="top-start"
                        style="font-size:14px;"
                        :disabled="
                          !data.keyword ||
                            data.keyword.length === 0 ||
                            data.keyword.join(';').length < 6
                        "
                      >
                        <div slot="content">
                          <div v-if="data.keyword.length > 0">
                            <div
                              v-for="(item, index) in data.keyword"
                              :key="index"
                              class="keyword"
                            >
                              {{ item }}
                            </div>
                          </div>
                          <div class="keyword1" v-else>暂无关键词</div>
                        </div>

                        <span :id="data.page">{{
                          data.pageName + " " + ellipsis(data.keyword.join(";"))
                        }}</span>
                      </el-tooltip>
                    </span>
                  </el-tree>
                </el-tab-pane>
                <el-tab-pane label="原文信息" name="second">
                  <el-tree
                    ref="tree"
                    class="tree"
                    id="tree2"
                    :data="catalog"
                    node-key="page"
                    :props="defaultProps"
                    :highlight-current="true"
                    :current-node-key="currentPage"
                    @node-click="handleNodeClick"
                  >
                    <span slot-scope="{ data }" style="width:135px">
                      <el-tooltip
                        effect="light"
                        placement="top-start"
                        style="font-size:14px;"
                        :disabled="
                          !data.keyword ||
                            data.keyword.length === 0 ||
                            data.keyword.join(';').length < 6
                        "
                      >
                        <div slot="content">
                          <div v-if="data.keyword.length > 0">
                            <div
                              v-for="(item, index) in data.keyword"
                              :key="index"
                              class="keyword"
                            >
                              {{ item }}
                            </div>
                          </div>
                          <div class="keyword1" v-else>暂无关键词</div>
                        </div>

                        <span :id="data.page"
                          >{{
                            data.pageName +
                              " " +
                              ellipsis(data.keyword.join(";"))
                          }}
                        </span>
                      </el-tooltip>
                    </span>
                  </el-tree>
                </el-tab-pane>
              </el-tabs>
            </div>

            <img
              src="@/assets/images/bookIcons/leftmenubottom.png"
              alt=""
              class="img-bottom"
            />
          </div>
        </div>
        <div class="middle-menu">
          <keep-alive>
            <retrieve-description-book
              v-if="activeName === 'first'"
              :bookId="bookId"
              :traditional="traditional"
              @get-book-info="handleSearchChange"
            ></retrieve-description-book>
            <retrieve-tab-display-book
              v-if="activeName === 'second'"
              ref="retrieveTabDisplayBook"
              :traditional="traditional"
              :total="total"
              :bookId="bookId"
              :bookName="bookName"
              :isFree="isFree"
              :currentPage="currentPage"
              :current-node-key="currentPage"
              @changePage="changePage"
              @get-data="handleSearchChange"
            ></retrieve-tab-display-book>
          </keep-alive>
        </div>
        <div class="right-menu">
          <RetrieveRightMenu
            ref="rightmenu"
            :bookId="bookId"
            :currentPage="currentPage"
            :isCollected="isCollected"
            :traditional.sync="traditional"
            @changeCurrentPage="changeCurrentPage"
            @search="searchBoxShow = !searchBoxShow"
          ></RetrieveRightMenu>
        </div>
      </div>
    </div>
    <search-box
      ref="searchBox"
      :selector-list="[
        '.retrieve-description-book',
        '.display .textarea',
        '#sDivId'
      ]"
      v-show="searchBoxShow"
      :before-jump="beforeSearchResultJump"
      @close="searchBoxShow = false"
    />
  </div>
</template>

<script>
import RetrieveDetailSearch from '@/components/RetrieveDetailSearch.vue'
import RetrieveLeftMenu from '@/components/RetrieveLeftMenu'
import RetrieveRightMenu from '@/components/RetrieveRightMenu.vue'
import RetrieveTabDisplayBook from '../../components/RetrieveTabDisplayBook.vue'
import RetrieveDescriptionBook from '../../components/RetrieveDescriptionBook.vue'
import SearchBox from '@/components/SearchBox'

export default {
  name: 'BookDetail',
  components: {
    RetrieveDetailSearch,
    RetrieveLeftMenu,
    RetrieveRightMenu,
    RetrieveTabDisplayBook,
    RetrieveDescriptionBook,
    SearchBox
  },
  data () {
    return {
      catalog: [],
      defaultProps: {
        children: 'children',
        label: 'pageName'
      },
      activeName: 'second',
      isShow: true,
      bookId: 0,
      currentPage: 1,
      total: 0,
      bookName: '',
      traditional: false,
      searchBoxShow: false,
      isCollected: false,
      isFree: 0,
      defaultPermission: 40,
      userId: -1
    }
  },
  mounted () {
    this.bookId = this.$route.query.book
    this.getBookInfo()
    // if (this.$route.query.page) {
    //   this.currentPage = Number(this.$route.query.page)
    //   console.log('yema', this.currentPage)
    //   //   this.$forceUpdate()
    // }
    // this.$refs.tree.setCurrentKey(this.currentPage)
    if (this.$route.query.note) {
      this.$refs.rightmenu.handleOpenNote()
    }
    // 检查是否被收藏
    if (localStorage.getItem('isLogined') === 'true') {
      let userId = localStorage.getItem('userId')
      this.userId = localStorage.getItem('userId')
      let url1 = 'retrieve/storeBook/hasBooksInBookStore?userId=' + userId +
      '&bookIds=' + this.bookId
      this.$http.post(url1).then(res => {
        // console.log(res.data.data)
        if (String(res.data.data[0].isInStoreBook) === 'true') {
          this.isCollected = true
          console.log('已经被收藏', this.isCollected)
        } else {
          this.isCollected = false
          console.log('未被收藏', this.isCollected)
        }
        // this.$bus.$emit('collectSuccess', this.bookId)
      })
      let url = '/retrieve/search/search'
      this.$global.searchDTO = {
        keyword: '',
        currentPage: 1,
        pageSize: 10,
        sortingMethod: '',
        reverseOrder: 0,
        userId: userId,
        freeBook: 0,
        tryRead: 0,
        customBook: 0,
        exactSearch: 1,
        returnType: 'sidebar',
        sideBarInfo: {
          sideBarClassify: [],
          sideBarLibrarySite: [],
          sideBarDynasty: [],
          sideBarEdition: [],
          sideBarYear: [],
          sideBarAuthor: []
        }
      }
      this.$http.post(url, this.$global.searchDTO).then(res => {
        this.sideBarInfo = res.data.data.sideBarInfo
        this.$bus.$emit('updateSideBarInfo', res.data.data.sideBarInfo)
      })
    }
    this.getDirectoryTree()
  },
  methods: {
    changeShow () {
      this.isShow = false
    },
    getBookInfo () {
      const params = new URLSearchParams()
      const url = 'retrieve/book/getBookInfo'
      params.append('bookId', this.bookId)
      this.$http.post(url, params).then(res => {
        // console.log(res)
        if (res.data.status === 200 && res.status === 200) {
          var info = res.data.data
          this.bookName = info.bookName
          this.isFree = info.isFree
          if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page)
            console.log('yema', this.currentPage)
            //   this.$forceUpdate()
          }
          console.log('info', info)
        } else {
          this.$message({
            type: 'error',
            message: res.data
          })
        }
      })
    },
    getDirectoryTree () {
      console.log('query', this.bookId)
      let params = new URLSearchParams()
      let url = 'retrieve/book/getDirectoryAll'
      params.append('bookId', this.bookId)
      this.$http.post(url, params).then(res => {
        if (res.data.status === 200 && res.status === 200) {
          //   var tempData = res.data.data
          //   console.log('tempData', tempData)
          //   this.total = Number(tempData[tempData.length - 1].page)
          this.total = res.data.data.total
          var list = res.data.data.list
          //   var tempData = this.sortData(res.data.data, 'page')
          //   console.log('this.catalog', tempData)

          this.catalog = list.filter(item => item.parentId === 0)
          list.forEach(item => {
            if (item.parentId !== 0) {
              let parent = list.find(temp => temp.pageName === item.parentId)
              if (parent.children === undefined) {
                parent.children = [item]
              } else {
                parent.children.push(item)
              }
            }
          })
          console.log('this.catalog2', this.catalog)
          this.changeTree()
        } else {
          this.$message({
            type: 'error',
            message: res.data
          })
          console.log(res)
        }
      })
    },
    sortData (array, key) {
      return array.sort(function (a, b) {
        var x = a[key]
        var y = b[key]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    changCatalogPage (pageId) {
      console.log('page', pageId)
      this.currentPage = pageId
      this.activeName = 'second'
    },
    handleNodeClick (data) {
      this.currentPage = data.page
      this.activeName = 'second'
    },
    changeCurrentPage (page) {
      this.currentPage = page
      console.log('pagedd', this.currentPage)
      //   this.$emit('changeCurrentPage', this.currentPage)
    },
    changePage (page) {
      this.currentPage = page
    },
    handleSearchChange () {
      if (this.searchBoxShow) {
        this.$nextTick(() => {
          this.$refs.searchBox.search()
        })
      }
    },
    beforeSearchResultJump (index, selector) {
      if (selector === '.retrieve-description-book') {
        this.activeName = 'first'
      } else {
        this.activeName = 'second'
        if (selector === '#sDivId') {
          this.$refs.retrieveTabDisplayBook.changeTabIndex(3)
        } else {
          this.$refs.retrieveTabDisplayBook.changeTabIndex(2)
        }
      }
    },
    expandParents (node) {
      node.expanded = true
      if (node.parent) {
        this.expandParents(node.parent)
      }
    },
    changeTree () {
      this.$nextTick(() => {
        console.log('11page', this.currentPage)
        this.$refs.tree.setCurrentKey(this.currentPage)
        // setTimeout(() => {
        const selected = this.$refs.tree.getNode(this.currentPage)
        console.log('selected', selected)
        if (
          this.$refs.tree.getNode(selected) &&
          this.$refs.tree.getNode(selected).parent
        ) {
          console.log('paerav')
          this.expandParents(this.$refs.tree.getNode(selected).parent)
        }
        setTimeout(() => {
          var node = document.getElementById(this.currentPage)
          if (node) {
            this.$nextTick(() => {
              var nodeOffsetTop = document.getElementById(this.currentPage).offsetTop
              var parentNodeClientHeight = document.getElementById('tree2').clientHeight
              if (nodeOffsetTop > parentNodeClientHeight) {
                document.getElementById('tree2').scrollTop = nodeOffsetTop - parentNodeClientHeight / 2
              }
            })
          }
        }, 100)
      })
    },
    ellipsis (str, len = 6) {
      if (str.length > len) {
        return str.substring(0, len) + '...'
      } else {
        return str
      }
    }
  },
  watch: {
    isShow () {
      this.$refs.retrieveTabDisplayBook.rebuildViewer()
    },
    currentPage: {
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.changeTree()
        }
      }
    },
    activeName () {
      this.handleSearchChange()
    },
    searchBoxShow () {
      this.handleSearchChange()
    }
    // currentPage () {
    // //   this.expandNodes(this.currentPage)
    //   this.changeTree()
    // }
  }
}
</script>

<style scoped>
.box {
  display: flex;
}
.retrieve-index {
  background-image: url(../../assets/images/background.png);
  background-size: 110%;
  background-position-x: center;
  background-position-y: -250px;
  background-repeat: no-repeat;
  background-color: #f7efe7;
  padding-top: 38px;
  min-height: 1080px;
  padding-bottom: 50px;
}

.book-top {
  position: relative;
  margin: 0 auto;
  top: -50px;
  width: 1202px;
  height: 99px;
  background-color: rgba(158, 92, 29, 0.05);
  border-radius: 0px 0px 0px 0px;
}

.book-middle {
  width: 1269px;
  height: 724px;
  position: relative;
  margin: 0 auto;
  top: -50px;
  right: -34px;
}

.left-menu {
  width: 220px;
  height: 724px;
  background-color: #ffffff;
  position: relative;
  display: inline-flex;
  flex-direction: column;
}
::-webkit-scrollbar {
  background-color: #f5eee8;
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
  background-color: #9e5c1d;
}
.middle-menu {
  height: 724px;
  background-color: #ffffff;
  margin-left: 18px;
  flex: 1 1 auto;
}

.right-menu {
  width: 60px;
  height: 724px;
  margin-left: 7px;
}

.button-class {
  width: 18px;
  height: 724px;
  vertical-align: middle;
  display: flex;
  align-items: center;
}

.hide {
  position: relative;
  width: 15px;
  height: 91px;
  border-radius: 5px 0px 0px 5px;
  cursor: pointer;
}

.tab {
  height: 675px;
}
.tab >>> .el-tabs__header {
  margin: 0 0 1px 0;
}

.tab >>> .el-tabs__item.is-active {
  color: #ffffff;
  background-color: #9e5c1d;
}

.tab >>> .el-tabs__item {
  color: #9e5c1d;
  background-color: #faf7f3;
  border: 0;
  /* width: 103px; */
  height: 35px;
  font-size: 16px;
}

.tab >>> .el-tabs__item:first-child {
  margin: 0 8px 0 1px;
}

.tab >>> .el-tabs__nav {
  border-bottom: 1px solid #9e5c1d;
}
.tree /deep/ .el-tree-node .el-tree-node__content {
  height: 40px;
  font-size: 16px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #634c37;
  text-align: left;
  /* padding:12px 0 0 0 ; */
  line-height: 40px;
  margin-bottom: 2px;
  background-image: url(../../assets/images/bookIcons/leftmenu1.png);
}
.tree {
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
  height: 638px;
}
.tree /deep/ .is-current > .el-tree-node__content {
  background: #9e5c1d !important;
  color: #fff !important;
}
.tree /deep/ .el-tree-node__label {
  display: inline-block;
  width: 72%;
}
.tree /deep/ .is-current > .el-tree-node__content:after {
  color: #ffffff;
  font-size: 40px;
  position: relative;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
.tree /deep/ .el-tree-node__children .el-tree-node__content {
  padding-left: 10px !important;
  width: 216px;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #634c37;
  text-align: left;
  height: 40px;
  background: #ffffff;
}
.tree /deep/ .el-tree-node__children .is-current .el-tree-node__content {
  background: #f5eee8 !important;
  color: #9e5c1d !important;
}
.tree /deep/ .el-tree-node__children .el-tree-node__content {
  color: #634c37 !important;
}
.tree /deep/ .el-tree-node__children .el-tree-node__content:hover {
  color: #9e5c1d !important;
  background-color: #ecded1 !important;
  border-color: #9e5c1d !important;
}
/* .tree /deep/ .el-tree-node__children .is-current .el-tree-node__content:after {
  content: "\2022";
  font-size: 40px;
  position: relative;
  right: 0px;
  bottom: 0;
  cursor: pointer;
  color: #fff !important;
} */
.tree .el-tree-node__expand-icon {
  color: #fff !important;
}
.el-tree-node__expand-icon.is-leaf {
  color: transparent !important;
}
.submenu >>> .el-menu-item:hover {
  color: #9e5c1d !important;
  background-color: #ecded1 !important;
  border-color: #9e5c1d !important;
}

.submenu >>> .el-submenu__title {
  height: 40px;
  font-size: 16px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #634c37;
  text-align: left;
  /* padding:12px 0 0 0 ; */
  line-height: 40px;
  margin-bottom: 2px;
  background-image: url(../../assets/images/bookIcons/leftmenu1.png);
}

.submenu >>> .el-icon-arrow-down:before {
  background: url(../../assets/images/bookIcons/down.png);
  content: "";
  display: block;
  width: 15px;
  height: 20px;
  font-size: 18px;
  background-size: 15px;
}

.submenu >>> .el-menu-item {
  padding-left: 26px !important;
  width: 216px;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #634c37;
  text-align: left;
  height: 40px;
}
.menu-item >>> .el-submenu .el-menu-item {
  height: 40px;
}
.point {
  width: 8.49px;
  height: 8.49px;
  margin-right: 5px;
}

.img-top {
  width: 220px;
  display: flex;
  align-items: top;
  margin-bottom: 7px;
}

.img-bottom {
  position: absolute;
  width: 220px;
  bottom: 0;
  left: 0;
  margin-bottom: 0;
}

.keyword {
  display: inline;
  /* margin: 8px; */
  color: #634c37;
  font-size: 14px;
}
.keyword1 {
  display: inline;
  /* margin: 8px; */
  color: #634c37;
  font-size: 14px;
}
.keyword::after {
  content: ";";
}
.bookName {
  color: #ffffff;
  font-size: 16px;
  line-height: 35px;
  height: 35px;
  background: #9e5c1d;
}
</style>



// WEBPACK FOOTER //
// src/views/retrieve/BookDetail.vue